export type { SlotProps } from '@radix-ui/react-slot'
export { Slot, Slottable } from '@radix-ui/react-slot'
